// Please describe here if you customized this file

export const responsive_utils = {};

responsive_utils.on_event_scroll = function (e) {
  // console.log("event_scroll(e) ");
  // console.log(e);
  let window_scrolled_px = document.documentElement.scrollTop;
  // console.log(window_scrolled_px);

  // if (window_scrolled_px >= 2) {
  if (window_scrolled_px > 1) {
    // document.documentElement.classList.add('scrolled'); // html element
    document.body.classList.add('scrolled'); // body
  } else {
    // document.documentElement.classList.remove('scrolled'); // html element
    document.body.classList.remove('scrolled'); // body
  }

  if (window_scrolled_px >= 400) {
    // document.documentElement.classList.add('scrolled'); // html element
    document.body.classList.add('scope-scrolled-bellow-sidebar'); // body
  } else {
    // document.documentElement.classList.remove('scrolled'); // html element
    document.body.classList.remove('scope-scrolled-bellow-sidebar'); // body
  }
}

responsive_utils.init = function () {
  window.onscroll = responsive_utils.on_event_scroll;
}


/*
// JQUERY
function initResponsive() {
  console.log("reponsive.js - initResponsive() ");
  $(window).scroll(function () {
    var scroll = $(window).scrollTop();
    if (scroll >= 2) {
      $('body').removeClass('scrolled').addClass('scrolled');
    } else {
      $('body').removeClass('scrolled');
    }
  });
  // $(window).resize(); // ??? https://api.jquery.com/resize/
  $(window).scroll(); // ??? https://api.jquery.com/scroll/
}
*/
